import Vue from 'vue'
import VueRouter from "vue-router";
import HomeView from "../page/home";
import WellView from "../page/wellreceived";
import PrincessView from "../page/princess";
import WelcomeView from "../page/welcome";
import authM from "../auth";

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/', name: '首页', icon: 'el-icon-s-promotion', key: '1', component: HomeView,
      meta: {
        metaInfo: {
          title: '西雅图桃桃私人会所',
          keywords: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
          description: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
        }
      }
    },
    {
      path: '/welcome', name: '首页', icon: 'el-icon-s-home', key: '6', component: HomeView,
      meta: {
        metaInfo: {
          title: '西雅图桃桃私人会所',
          keywords: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
          description: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
        }
      }
    },
    {
      path: '/wellreceived', name: '好评管理', icon: 'el-icon-s-data', key: '7', component: WellView,
      meta: {
        metaInfo: {
          title: '西雅图桃桃私人会所',
          keywords: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
          description: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
        }
      }
    },
    {
      path: '/princess:id', name: 'princess', icon: 'el-icon-s-data', key: '2', component: PrincessView,
      meta: {
        metaInfo: {
          title: '小姐-西雅图桃桃私人会所',
          keywords: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
          description: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
        }
      }
    },
    {
      path: '/princess', name: 'princess', icon: 'el-icon-s-data', key: '3', component: PrincessView,
      meta: {
        metaInfo: {
          title: '小姐-西雅图桃桃私人会所',
          keywords: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
          description: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
        }
      }
    },
    {
      path: '/logout', name: '退出', key: '7',
      beforeEnter(to, from, next) {
        authM.logout();
        next('/welcome')
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js